import groq from 'groq'

import { frameBuilderImageFragment } from './image'

const frameBuilderDefaultFrameFragment = groq`
  width,
  height,
  previewImage {
    ${frameBuilderImageFragment}
  },
  passepartoutPreviewImage {
    ${frameBuilderImageFragment}
  },
  backgroundColor {
    hex,
  },
  backgroundColorPresets[] {
    hex,
  },
  profileTexture->{
    profile,
    texture,
  },
  passepartoutColor,
  passepartoutWidth,
  passepartoutHeight,
  glass,
  spacerSize,
  spacerColor,
`

export const frameBuilderDefaultFrameObjectFragment = groq`
  "defaultFrame": *[
    _type == "frameBuilderDefaultFrame" &&
    locale == $locale
  ][0] {
    ${frameBuilderDefaultFrameFragment}
  },
`
